import PropTypes from 'prop-types';

import Modal from 'honeydew/Modal';

export function PlanRangeInfoModal({ open, planMaximum, planMinimum, setOpen }) {
    return (
        <Modal open={open} onClose={() => setOpen(false)} headline="Your personalized weekly grocery plan">
            <p className="text-body-sm mt-20 text-grey">
                We’ll start your cart with ${planMinimum}-{planMaximum} of groceries. Add or remove anything in your
                personalized shopping cart during your shopping window. We’ll do our best to accommodate any dietary
                preferences and grocery categories you selected, but please note that we cannot guarantee that all
                products will reflect those preferences.
            </p>
        </Modal>
    );
}

PlanRangeInfoModal.propTypes = {
    open: PropTypes.bool.isRequired,
    planMaximum: PropTypes.number,
    planMinimum: PropTypes.number,
    setOpen: PropTypes.func.isRequired,
};

PlanRangeInfoModal.defaultProps = {
    planMaximum: 0,
    planMinimum: 0,
};
